<template>
	<div class="menu" @click="$emit('close')">
		<div class="logo">
			<img src="/Watermark v3 black.png" class="logo" @click="$emit('close')"/>
		</div>
		<div class="menu-list">
			<RouterLink
				class="onload nav-link px-3"
				:class="[n.color, n.font]"
				v-for="n in nav_data"
				:to="n.to"
				@click="$emit('close')"
				>
				{{ n.text }}
			</RouterLink>
			<a
				class="onload nav-link px-3 white blog"
				href="https://blog.shadowlerone.ca"
			>
				blog
			</a>
		</div>
	</div>
</template>

<script setup>
import nav_data from "@/data/nav.json";
const emit = defineEmits(["close"]);
</script>
